import React, {useEffect, useRef} from 'react';
import TextBox from 'devextreme-react/text-box';

const NumberEditor = ({ value, setValue }) => {
    const textBoxRef = useRef(null);

    const formatInput = (input) => {
        // Убираем всё, кроме цифр, точек и запятых
        input = input.replace(/[^0-9.,]/g, '');

        // Оставляем только один десятичный разделитель
        const separators = input.match(/[.,]/g);
        if (separators && separators.length > 1) {
            const firstIndex = input.search(/[.,]/);
            input = input.slice(0, firstIndex + 1) +
                input.slice(firstIndex + 1).replace(/[.,]/g, '');
        }

        // Делим на целую и дробную части
        let [intPart, decimalPart] = input.includes('.')
            ? input.split('.')
            : input.includes(',') ?
                input.split(',') :
                [input];

        // Ограничиваем целую часть (до 9)
        if (intPart && intPart.length > 9) {
            intPart = intPart.slice(0, 9);
        }

        // Ограничиваем дробную часть (до 6)
        if (decimalPart && decimalPart.length > 6) {
            decimalPart = decimalPart.slice(0, 6);
        }

        // Собираем обратно
        const correctedValue = decimalPart !== undefined
            ? `${intPart}.${decimalPart}`
            : intPart;

        return {
            displayValue: correctedValue,
            numericValue: correctedValue === '' ? null : parseFloat(correctedValue),
        };
    };

    const handleInput = (e) => {
        const input = e.event.target.value;
        const { displayValue, numericValue } = formatInput(input);
        e.event.target.value = displayValue
        // Передаём значение в DataGrid
        setValue(numericValue);
    };

    // При изменении value извне — обновляем поле
    useEffect(() => {
        if (textBoxRef.current?.instance && value != null) {
            textBoxRef.current.instance.option('text', value.toString().replace('.', ','));
        }
    }, [value]);

    /*const onFocusIn = (e) => {
        if (e.event.target.value) {
            //setHasChanges( !!e.event.target.value )
        }
    };

    const onFocusOut = (e) => {
        if (e.event.target.value) {
            //setHasChanges( !!e.event.target.value )
        }
    };*/

    return (
        <TextBox
            ref={textBoxRef}
            defaultValue={value != null ? value.toString().replace('.', ',') : ''}
            onInput={handleInput}
            inputAttr={{ style: 'text-align: right;' }}
            /*onFocusIn={onFocusIn}
            onFocusOut={onFocusOut}*/
        />
    );
};

export default NumberEditor
